var _style, _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g, _rect2, _path23, _polygon, _path24, _path25, _path26, _path27, _path28, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportAnalysis518(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      width: 188
    },
    xmlSpace: "preserve",
    "data-imageid": "report-analysis-5-18",
    imageName: "Report Analysis 5",
    className: "illustrations_image",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0_report-analysis-5-18{fill:#68E1FD;}\n\t.st1_report-analysis-5-18{fill:#093F68;}\n\t.st2_report-analysis-5-18{fill:#FFFFFF;}\n\t.st3_report-analysis-5-18{fill:#DFEAEF;}\n\t.st4_report-analysis-5-18{fill:#FFBC0E;}\n\t.st5_report-analysis-5-18{fill:#F56132;}\n\t.st6_report-analysis-5-18{fill:#70CC40;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "data_report-analysis-5-18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.1,
    y: 132.6,
    className: "st0_report-analysis-5-18 targetColor",
    width: 185,
    height: 249.3,
    style: {
      fill: "#ff6c5f"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-5-18",
    d: "M351.1,383.8h-185c-1,0-1.9-0.8-1.9-1.9V132.6c0-1,0.8-1.9,1.9-1.9l0,0h185c1,0,1.9,0.8,1.9,1.9v249.3 C352.9,382.9,352.1,383.8,351.1,383.8L351.1,383.8z M167.9,380h181.3V134.4H167.9V380z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 118.1,
    className: "st2_report-analysis-5-18",
    width: 185,
    height: 249.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-5-18",
    d: "M365,369.3H180c-1,0-1.9-0.8-1.9-1.9V118.1c0-1,0.8-1.9,1.9-1.9l0,0h185c1,0,1.9,0.8,1.9,1.9v249.3 C366.9,368.4,366.1,369.3,365,369.3z M181.9,365.6h181.3V120H181.9V365.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-5-18",
    d: "M220.4,211.5c-0.5,0-1-0.2-1.4-0.6c-0.7-0.8-0.6-1.9,0.1-2.6c0,0,0,0,0,0l33.4-29.7c0.5-0.5,1.3-0.6,2-0.3 l30.5,13.8l38.4-35.7c0.8-0.7,1.9-0.7,2.6,0.1c0.7,0.8,0.7,1.9-0.1,2.6l-39.3,36.5c-0.5,0.5-1.3,0.6-2,0.3l-30.5-13.9L221.6,211 C221.3,211.3,220.8,211.5,220.4,211.5z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st0_report-analysis-5-18 targetColor",
    cx: 285.1,
    cy: 194.4,
    r: 7.7,
    style: {
      fill: "#ff6c5f"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-5-18",
    d: "M285.1,204c-5.3,0-9.6-4.3-9.6-9.6s4.3-9.6,9.6-9.6c5.3,0,9.6,4.3,9.6,9.6l0,0 C294.7,199.7,290.4,204,285.1,204z M285.1,188.5c-3.2,0-5.9,2.6-5.9,5.9s2.6,5.9,5.9,5.9c3.2,0,5.9-2.6,5.9-5.9c0,0,0,0,0,0 C291,191.2,288.3,188.6,285.1,188.5L285.1,188.5z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st0_report-analysis-5-18 targetColor",
    cx: 253.8,
    cy: 179.9,
    r: 7.7,
    style: {
      fill: "#ff6c5f"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-5-18",
    d: "M253.8,189.5c-5.3,0-9.6-4.3-9.6-9.6c0-5.3,4.3-9.6,9.6-9.6c5.3,0,9.6,4.3,9.6,9.6 C263.3,185.2,259.1,189.5,253.8,189.5z M253.8,174.1c-3.2,0-5.9,2.6-5.9,5.9c0,3.2,2.6,5.9,5.9,5.9c3.2,0,5.9-2.6,5.9-5.9 C259.6,176.7,257,174.1,253.8,174.1L253.8,174.1z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st0_report-analysis-5-18 targetColor",
    cx: 324.7,
    cy: 158.8,
    r: 7.7,
    style: {
      fill: "#ff6c5f"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-5-18",
    d: "M324.7,168.4c-5.3,0-9.6-4.3-9.6-9.6c0-5.3,4.3-9.6,9.6-9.6c5.3,0,9.6,4.3,9.6,9.6c0,0,0,0,0,0 C334.3,164.1,330,168.4,324.7,168.4z M324.7,153c-3.2,0-5.9,2.6-5.9,5.9s2.6,5.9,5.9,5.9s5.9-2.6,5.9-5.9c0,0,0,0,0,0 C330.5,155.6,327.9,153,324.7,153L324.7,153z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st0_report-analysis-5-18 targetColor",
    cx: 220.4,
    cy: 209.6,
    r: 7.7,
    style: {
      fill: "#ff6c5f"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-5-18",
    d: "M220.4,219.2c-5.3,0-9.6-4.3-9.6-9.6c0-5.3,4.3-9.6,9.6-9.6c5.3,0,9.6,4.3,9.6,9.6l0,0 C230,214.9,225.7,219.2,220.4,219.2z M220.4,203.8c-3.2,0-5.9,2.6-5.9,5.9c0,3.2,2.6,5.9,5.9,5.9c3.2,0,5.9-2.6,5.9-5.9 c0,0,0,0,0,0C226.3,206.4,223.6,203.8,220.4,203.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3_report-analysis-5-18",
    d: "M345.5,238H199.6c-1,0-1.9-0.8-1.9-1.9l0,0v-94c0-1,0.8-1.9,1.9-1.9s1.9,0.8,1.9,1.9v92.1h144.1 c1,0,1.9,0.8,1.9,1.9S346.5,238,345.5,238L345.5,238z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0_report-analysis-5-18 targetColor",
    d: "M284,301.9c0,23.3-18.9,42.2-42.2,42.2s-42.2-18.9-42.2-42.2c0-23.3,18.9-42.2,42.2-42.2l0,0 c23.1-0.2,42,18.4,42.2,41.5C284,301.4,284,301.7,284,301.9z",
    style: {
      fill: "#ff6c5f"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-5-18",
    d: "M241.8,346c-24.4,0-44.1-19.7-44.1-44.1c0-24.4,19.7-44.1,44.1-44.1s44.1,19.7,44.1,44.1c0,5.5-1,10.9-3,16 c-1.9,4.8-4.6,9.3-8,13.1C266.5,340.6,254.5,346,241.8,346L241.8,346z M241.8,261.5c-22.3,0-40.4,18.1-40.4,40.4 c0,22.3,18.1,40.4,40.4,40.4c0,0,0,0,0,0c4.3,0,8.5-0.7,12.6-2c6.8-2.2,12.9-6.3,17.7-11.7c6.5-7.4,10.1-16.8,10.1-26.7 C282.2,279.6,264.1,261.6,241.8,261.5L241.8,261.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2_report-analysis-5-18",
    d: "M284,301.9c0,10.3-3.8,20.2-10.5,27.9l-31.7-27.9v-42.2C265.1,259.7,284,278.6,284,301.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-5-18",
    d: "M273.5,331.7c-0.5,0-0.9-0.2-1.2-0.5l-31.7-27.9c-0.4-0.3-0.6-0.9-0.6-1.4v-42.2c0-1,0.8-1.9,1.9-1.9 c24.4,0,44.1,19.8,44.1,44.1c0,5.5-1,10.9-3,16c-1.9,4.8-4.6,9.3-8,13.1C274.5,331.4,274,331.7,273.5,331.7z M243.6,301.1 l29.6,26.1c5.8-7.2,8.9-16.1,8.9-25.2c0-21.6-17-39.3-38.5-40.3L243.6,301.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2_report-analysis-5-18",
    d: "M281.1,317.2C276.5,329,267,338.1,255,342l-13.2-40.1L281.1,317.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-5-18",
    d: "M255,343.9c-0.8,0-1.5-0.5-1.8-1.3L240,302.5c-0.3-1,0.2-2,1.2-2.4c0.4-0.1,0.8-0.1,1.2,0l39.3,15.3 c1,0.4,1.4,1.4,1.1,2.4c0,0,0,0,0,0c-1.9,4.8-4.6,9.3-8,13.1c-5.2,5.9-11.9,10.3-19.3,12.7C255.4,343.8,255.2,343.9,255,343.9z M244.8,305.1l11.4,34.5c10-3.8,18.1-11.5,22.5-21.3L244.8,305.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3_report-analysis-5-18",
    d: "M339.7,267.1h-29.2c-1,0-1.9-0.8-1.9-1.9c0-1,0.8-1.9,1.9-1.9h29.2c1,0,1.9,0.8,1.9,1.9 C341.6,266.2,340.7,267.1,339.7,267.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st3_report-analysis-5-18",
    d: "M339.7,284.9H302c-1,0-1.9-0.8-1.9-1.9c0-1,0.8-1.9,1.9-1.9h37.7c1,0,1.9,0.8,1.9,1.9 C341.6,284,340.7,284.9,339.7,284.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st3_report-analysis-5-18",
    d: "M339.7,302.6h-10.8c-1,0-1.9-0.8-1.9-1.9c0-1,0.8-1.9,1.9-1.9h10.8c1,0,1.9,0.8,1.9,1.9 C341.6,301.8,340.7,302.6,339.7,302.6z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st3_report-analysis-5-18",
    d: "M312.8,302.6H302c-1,0-1.9-0.8-1.9-1.9c0-1,0.8-1.9,1.9-1.9h10.8c1,0,1.9,0.8,1.9,1.9 C314.7,301.8,313.9,302.6,312.8,302.6L312.8,302.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st3_report-analysis-5-18",
    d: "M339.7,320.4H302c-1,0-1.9-0.8-1.9-1.9c0-1,0.8-1.9,1.9-1.9h37.7c1,0,1.9,0.8,1.9,1.9 C341.6,319.6,340.7,320.4,339.7,320.4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st3_report-analysis-5-18",
    d: "M319.1,338.2H302c-1,0-1.9-0.8-1.9-1.9c0-1,0.8-1.9,1.9-1.9h17.1c1,0,1.9,0.8,1.9,1.9 C321,337.3,320.1,338.2,319.1,338.2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st3_report-analysis-5-18",
    d: "M253.8,144h-25.6c-1,0-1.9-0.8-1.9-1.9s0.8-1.9,1.9-1.9h25.6c1,0,1.9,0.8,1.9,1.9S254.8,144,253.8,144 L253.8,144z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st3_report-analysis-5-18",
    d: "M236.9,156.9h-8.8c-1,0-1.9-0.8-1.9-1.9s0.8-1.9,1.9-1.9h8.8c1,0,1.9,0.8,1.9,1.9S237.9,156.9,236.9,156.9z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st3_report-analysis-5-18",
    d: "M281.1,144h-8.6c-1,0-1.9-0.8-1.9-1.9s0.8-1.9,1.9-1.9h8.6c1,0,1.9,0.8,1.9,1.9S282.1,144,281.1,144z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass_report-analysis-5-18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.9,
    y: 253.5,
    className: "st1_report-analysis-5-18",
    width: 13.7,
    height: 50.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-5-18",
    d: "M146.6,305.7h-13.7c-1,0-1.9-0.8-1.9-1.9v-50.3c0-1,0.8-1.9,1.9-1.9l0,0h13.7c1,0,1.9,0.8,1.9,1.9l0,0v50.3 C148.5,304.8,147.7,305.7,146.6,305.7L146.6,305.7z M134.8,302h10v-46.6h-10V302z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4_report-analysis-5-18",
    d: "M133.7,297h12.1c1.8,0,3.3,1.5,3.3,3.3v78c0,1.8-1.5,3.3-3.3,3.3h-12.1c-1.8,0-3.3-1.5-3.3-3.3v-78 C130.4,298.5,131.9,297,133.7,297z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-5-18",
    d: "M143,383.6h-6.4c-4.5,0-8.1-3.6-8.1-8.1v-72.2c0-4.5,3.6-8.1,8.1-8.1h6.4c4.5,0,8.1,3.6,8.1,8.1v72.2 C151.1,379.9,147.5,383.6,143,383.6z M136.6,298.9c-2.4,0-4.4,1.9-4.4,4.4l0,0v72.2c0,2.4,1.9,4.4,4.4,4.4h6.4c2.4,0,4.4-2,4.4-4.4 v-72.2c0-2.4-2-4.4-4.4-4.4H136.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.088901e-02 -0.9975 0.9975 7.088901e-02 -102.5358 354.3586)",
    className: "st4_report-analysis-5-18",
    cx: 138.9,
    cy: 232.2,
    rx: 44.9,
    ry: 44.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-5-18",
    d: "M139,279c-25.8,0-46.8-20.9-46.8-46.8s20.9-46.8,46.8-46.8c25.8,0,46.8,20.9,46.8,46.8c0,0,0,0,0,0 C185.8,258,164.8,279,139,279z M139,189.1c-23.8,0-43.1,19.2-43.2,43s19.2,43.1,43,43.2s43.1-19.2,43.2-43c0,0,0,0,0-0.1 C182,208.5,162.7,189.2,139,189.1L139,189.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2_report-analysis-5-18",
    cx: 138.9,
    cy: 232.2,
    r: 31.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-5-18",
    d: "M139,265.9c-18.6,0-33.6-15.1-33.6-33.6s15.1-33.6,33.6-33.6c18.6,0,33.6,15.1,33.6,33.6 C172.6,250.8,157.6,265.8,139,265.9z M139,202.3c-16.5,0-29.9,13.4-29.9,29.9s13.4,29.9,29.9,29.9s29.9-13.4,29.9-29.9 C168.9,215.7,155.5,202.3,139,202.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3_report-analysis-5-18",
    d: "M120.3,243.6c-1,0-1.9-0.9-1.8-1.9c0-0.5,0.2-0.9,0.5-1.3l20.1-20.1c0.7-0.7,1.9-0.7,2.6,0 c0.7,0.7,0.7,1.9,0,2.6L121.6,243C121.3,243.4,120.8,243.6,120.3,243.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3_report-analysis-5-18",
    d: "M139.1,251.1c-1,0-1.9-0.8-1.9-1.9c0-0.5,0.2-1,0.5-1.3l15.1-15.2c0.7-0.8,1.9-0.9,2.6-0.2s0.9,1.9,0.2,2.6 c-0.1,0.1-0.1,0.1-0.2,0.2l-15.1,15.2C140.1,250.9,139.6,251.1,139.1,251.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "pen_report-analysis-5-18"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 378.1,
    y: 237.3,
    className: "st5_report-analysis-5-18",
    width: 15.8,
    height: 113.6
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-5-18",
    d: "M393.9,352.8h-15.8c-1,0-1.9-0.8-1.9-1.9V237.3c0-1,0.8-1.9,1.9-1.9h15.8c1,0,1.9,0.8,1.9,1.9V351 C395.7,352,394.9,352.8,393.9,352.8z M380,349.1h12V239.2h-12V349.1z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st5_report-analysis-5-18",
    points: "387.3,371.5 393.9,351 378.1,351 384.7,371.5 \t"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-5-18",
    d: "M387.3,373.3h-2.6c-0.8,0-1.5-0.5-1.8-1.3l-6.6-20.5c-0.3-1,0.2-2,1.2-2.3c0.2-0.1,0.4-0.1,0.6-0.1h15.8 c0.6,0,1.2,0.3,1.5,0.8c0.4,0.5,0.4,1.1,0.3,1.7L389,372C388.8,372.8,388.1,373.3,387.3,373.3z M380.7,352.8l5.3,16.6l5.3-16.6 L380.7,352.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0_report-analysis-5-18 targetColor",
    d: "M384.7,371.5h2.6l0,0v7.5c0,0.4-0.3,0.7-0.7,0.7l0,0h-1.2c-0.4,0-0.7-0.3-0.7-0.7l0,0V371.5L384.7,371.5 L384.7,371.5z",
    style: {
      fill: "#ff6c5f"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-5-18",
    d: "M386,381.5c-1.7,0-3.1-1.4-3.1-3.1v-6.9c0-1,0.8-1.9,1.9-1.9h2.6c1,0,1.9,0.8,1.9,1.9v6.9 C389.1,380.1,387.7,381.5,386,381.5z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st5_report-analysis-5-18",
    d: "M378,230.4h15.8c1.4,0,2.6,1.2,2.6,2.6v66.3l0,0h-21l0,0V233C375.4,231.6,376.6,230.4,378,230.4z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-5-18",
    d: "M396.4,301.2h-21c-1,0-1.9-0.8-1.9-1.9v-64.1c0-3.7,3-6.7,6.7-6.7h11.3c3.7,0,6.7,3,6.7,6.7v64.1 C398.3,300.4,397.4,301.2,396.4,301.2z M377.3,297.5h17.3v-62.2c0-1.7-1.3-3-3-3h-11.3c-1.7,0-3,1.3-3,3V297.5z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-5-18",
    d: "M402.4,287.1c-0.5,0-1-0.2-1.3-0.5c-6.1-6.1-2.6-18.7,0.5-29.7c1.5-5.2,3-10.7,2.5-12.8 c-0.5-1.9-1.3-2.2-1.6-2.4c-1.5-0.6-4.1,0.4-5.1,1c-0.9,0.6-2,0.3-2.6-0.5c-0.6-0.9-0.3-2,0.5-2.6c0,0,0.1-0.1,0.1-0.1 c0.5-0.3,4.8-2.7,8.4-1.2c2,0.9,3.4,2.8,3.7,4.9c0.7,3.1-0.7,8.2-2.5,14.7c-2.7,9.6-6,21.5-1.4,26.1c0.7,0.7,0.7,1.9,0,2.6 C403.3,287,402.9,287.2,402.4,287.1L402.4,287.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ruler_report-analysis-5-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6_report-analysis-5-18",
    d: "M317.4,213.5h80.3v-87.1L317.4,213.5z M384.7,200h-37l37-40.1V200z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1_report-analysis-5-18",
    d: "M397.7,215.3h-80.3c-1,0-1.9-0.8-1.9-1.9c0-0.5,0.2-0.9,0.5-1.3l80.3-87.1c0.7-0.8,1.9-0.8,2.6-0.1 c0.4,0.4,0.6,0.9,0.6,1.4v87.1C399.5,214.5,398.7,215.3,397.7,215.3C397.7,215.3,397.7,215.3,397.7,215.3z M321.6,211.6h74.2v-80.4 L321.6,211.6z M384.6,201.9h-37c-1,0-1.9-0.8-1.9-1.9c0-0.5,0.2-0.9,0.5-1.3l37-40.1c0.7-0.8,1.9-0.8,2.6-0.1 c0.4,0.4,0.6,0.9,0.6,1.4V200C386.5,201,385.7,201.8,384.6,201.9L384.6,201.9z M351.9,198.1h30.9v-33.5L351.9,198.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportAnalysis518);
export default __webpack_public_path__ + "static/media/report-analysis-5-18.3370b659091ee1e393fc45cb894f5308.svg";
export { ForwardRef as ReactComponent };